import { render } from "./ThemecustomCrud.vue?vue&type=template&id=11c50118&scoped=true"
import script from "./ThemecustomCrud.vue?vue&type=script&lang=js"
export * from "./ThemecustomCrud.vue?vue&type=script&lang=js"

import "./ThemecustomCrud.vue?vue&type=style&index=0&id=11c50118&lang=scss&scoped=true"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c50118"]])

export default __exports__